import { useMutation } from "@apollo/client";
import { BLOCK_SLOT, BlockSlotQuery } from "@App/graphql/mutations/blockSlot";
import { useState } from "react";
import { Slot } from "@App/types";
import { useCalculation } from "@App/hooks/useCalculation";
import { formatDate, toIsoString } from "@App/utils/dates";
import { useContext } from "@App/hooks/useContext";

export const useBlockSlot = () => {
  const {
    organization,
    service,
    garage,
    filterBrand,
    brand,
    generation,
    motorization,
    body,
    gearbox,
    mileage,
    initialRegistrationDate,
    subRepairs,
    equipments,
    premiumServices,
  } = useCalculation();

  const { getContext } = useContext();

  const [triedSlot, setTriedSlot] = useState(null);

  const [block, { loading, data, error }] = useMutation<BlockSlotQuery>(BLOCK_SLOT);

  const blockSlot = (slot: Slot) => {
    setTriedSlot(slot);

    block({
      context: getContext(garage),
      variables: {
        organization: organization ? organization.id : null,
        garage: garage ? garage.id : null,
        calendarId: slot.calendar_id,
        services: service ? [service.id] : null,
        startDate: slot ? toIsoString(slot.starts_at) : null,
        endDate: slot ? toIsoString(slot.ends_at) : null,
        brand: brand ? brand.id : filterBrand ? filterBrand.id : null,
        generation: generation ? generation.id : null,
        motorization: motorization ? motorization.id : null,
        body: body ? body.id : null,
        gearbox: gearbox ? gearbox.id : null,
        mileage: mileage,
        registrationDate: initialRegistrationDate
          ? formatDate(initialRegistrationDate, "yyyy-MM-dd")
          : null,
        premiumServices:
          premiumServices && premiumServices.length > 0 ? premiumServices.map((p) => p.id) : null,
        equipments: equipments.map((equipment) => equipment.name),
        subRepairs: subRepairs,
        session_id: slot && slot.session_id ? slot.session_id : null,
      },
    });
  };

  return {
    error,
    loading,
    triedSlot,
    blockedSlot: data ? data.block : null,
    blockSlot,
  };
};
